import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
    elements_count: {
        display: 'flex',
        alignItems: 'center',
        '& :first-child': {
            fontSize: '24px',
            marginRight: '4px',
            marginLeft: '10px',
            fontWeight: '600'
        }
    },
}));

export {useStyles}